import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
          light: {
            primary: "#d93954",
            secondary: '#000000',
            warning: "#d93954",
            error: "#d93954"
          }
        }
      }
});
